import { memberFeaturesQuery } from "@/api/me";
import { api, auth, queryClient } from "@/api/utils";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
  beforeLoad: async () => {
    async function routeToDefaultPage() {
      const features = await queryClient.ensureQueryData(memberFeaturesQuery);

      if (features.hasAllowanceMarketplace) {
        throw redirect({
          to: "/marketplace",
          search: prev => prev as any,
          replace: true,
        });
      }
      if (features.hasEapMarketplace) {
        throw redirect({
          to: "/eap",
          search: prev => prev,
          replace: true,
        });
      }
      if (features.hasAllowance && features.hasEap) {
        throw redirect({
          to: "/home",
          search: prev => prev,
          replace: true,
        });
      }
      if (features.hasAllowance || features.hasEap) {
        throw redirect({
          to: "/claims",
          search: prev => prev,
          replace: true,
        });
      }
      throw redirect({
        to: "/resources",
        replace: true,
      });
    }

    if (auth.hasAccessToken()) {
      queryClient.clear();
      await routeToDefaultPage();
    } else {
      try {
        await auth.renewAuthTokens(true);
        await api.auth.getMarketplaceUserInfo();
      } catch (e) {
        throw redirect({
          to: "/sign-in",
          replace: true,
        });
      }
      await routeToDefaultPage();
    }
  },
});
